import React, { useEffect, useState } from "react";
import clsx from "clsx";
import styles from "./styles.module.css";
import { useTranslation } from "react-i18next";
import LanguageToggle from "../../components/LanguageToggle/LanguageToggle";
import Separator from "../../components/Separator";
import UserItem from "./userItem";
import ClickableItemBox from "../../components/ClickableItemBox";
import { ReactComponent as ChatIcon } from "../../assets/help-filled-icon.svg";
import { ReactComponent as GameIcon } from "../../assets/game-icon.svg";
import { ReactComponent as FilesIcon } from "../../assets/files-icon.svg";
import { ReactComponent as ZupeeIcon } from "../../assets/zupee-exclamation-icon.svg";
import { ReactComponent as Banner } from "../../assets/help-page-banner.svg";
import { ReactComponent as LogoutIcon } from "../../assets/logout-icon.svg";
import logoutIcon from "../../assets/logout-icon.svg";
import { Link } from "react-router-dom";
import { NAVIGATION_ROUTES } from "../../constant";
import { logout, useTokenStore } from "../../storage/tokenState";
import _isEmpty from "lodash/isEmpty";
import BottomSheetModal from "../../components/BottomSheetModal";
import { useTournamentsListApi } from "../../api/useTournamentsListApi";
import PromotionBanner from "../../components/PromotionBanner";
import Skeleton from "../../components/Skeleton";
import Loader from "../../components/Loader";
import { useConfigStore } from "../../storage/configState";
import { FbPixelEvent_PageView } from "../../utils/FbPixel/fbPixel";
import { getPartnerId } from "../../utils/helpers/common";
import { FACEBOOK } from "../../utils/helpers/constants";

const Help: React.FC = () => {
  const { t } = useTranslation();
  const { token: userToken } = useTokenStore();
  const {helpScreenData} = useConfigStore.getState()?.homeScreenConfig || {};
  const [isLogoutModalOpen, setLogoutModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const language = localStorage.getItem("language") || "en";
  const bannerPath = helpScreenData?.banner?.imageUrl || "";
  const ctaLink = helpScreenData?.banner?.cta || {};

  const hasTrackedRef = React.useRef(false);
  
  useEffect(() => {
    if (getPartnerId() === FACEBOOK && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      FbPixelEvent_PageView();
    }
  }, []);

  const handleLogout = () => {
    setLoading(true);
    logout();
  }

  const logoutActions = [
    {
      label: t("dontLogout"),
      onClick: () => setLogoutModalOpen(false),
      btnClass: "primaryBtn",
    },
    { label: t("yesLogout"), onClick: handleLogout, btnClass: "secondaryBtn" },
  ];

  const items = [
    {
      icon: <ChatIcon />,
      link:NAVIGATION_ROUTES.FAQS,
      heading: t("helpSupportLabel"),
      subHeading: t("customerSupportSubHeading"),
    },
    {
      link: !_isEmpty(userToken)
        ? NAVIGATION_ROUTES.GAMEHISTORY
        : NAVIGATION_ROUTES.SIGNIN,
      icon: <GameIcon />,
      heading: t("gameHistoryLabel"),
      subHeading: t("viewGameHistory"),
    },
    {
      link: process.env.REACT_APP_MAIN_SITE_LINK
        ? `${process.env.REACT_APP_MAIN_SITE_LINK}/terms-and-conditions/`
        : "/",
      type: "EXTERNAL_LINK",
      icon: <FilesIcon />,
      heading: t("tAndCLabel"),
      subHeading: t("viewTAndC"),
    },
    {
      link: process.env.REACT_APP_MAIN_SITE_LINK
        ? `${process.env.REACT_APP_MAIN_SITE_LINK}/about-zupee/`
        : "/",
      type: "EXTERNAL_LINK",
      icon: <ZupeeIcon />,
      heading: t("aboutLabel"),
    },
    {
      onClick: () => setLogoutModalOpen(true),
      icon: <LogoutIcon />,
      heading: t("logout"),
      visibility: !_isEmpty(userToken),
    },
  ];

  if(loading) return <Loader transparent/>;
  return (
    <>
      <div
        className={clsx(
          styles.pageWrapper,
          styles.helpPage,
          "pageWrapper noHeader"
        )}
      >
        <UserItem />
        <Separator />
        <LanguageToggle />
        <Separator />
        {items
          .filter(({ visibility = true }) => visibility)
          .map(({ link, icon, heading, subHeading, onClick, type }, index) => (
            <React.Fragment key={index}>
              <ClickableItemBox
                link={link}
                type={type}
                icon={icon}
                heading={heading}
                subHeading={subHeading}
                onClick={onClick}
              />
              <Separator />
            </React.Fragment>
          ))}
        {false ? (
          <Skeleton variant="banner" />
        ) : (
          !_isEmpty(bannerPath) && (
              <PromotionBanner imageUrl={bannerPath} cta={ctaLink} />
          )
        )}
        <BottomSheetModal
          isOpen={isLogoutModalOpen}
          modalIcon={logoutIcon}
          title={t("loggingOut")}
          content={t("confirmLogout")}
          actions={logoutActions}
          onClose={() => setLogoutModalOpen(false)}
        />
      </div>
    </>
  );
};

export default Help;
